<template>
  <div id="app" data-app :class="`${$store.state.theme} ${$store.state.template}`" :style="$commonHelper.getTemplateVars()">
    <Home class="background"></Home>
    <v-snackbar v-model="$store.state.alert.show" :color="$store.state.alert.type" top right :timeout=5000>
      {{ $store.state.alert.message }}
    </v-snackbar>
  </div>
</template>

<script>
import Home from './components/Home.vue';

export default {
  name: 'App',
  components: {
    Home
  }
}
</script>